import { createFileRoute } from "@tanstack/react-router";
import { FileFormats } from "../../app/helpers/resultUploadHelper";
import Upload from "../../app/views/resultUpload";

const ElisaUpload = () => <Upload enabledFormats={[FileFormats.ELISA]} />;

export const Route = createFileRoute("/elisa/upload")({
  component: ElisaUpload,
});
